import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kiene-gemeinkosten-bulk-upload-dialog',
    templateUrl: './gemeinkosten-bulk-upload-dialog.component.html',
    styleUrls: ['./gemeinkosten-bulk-upload-dialog.component.scss'],
})
export class GemeinkostenBulkUploadDialogComponent {
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

    files: File[] = [];
    dragActive = false;

    constructor(private readonly dialogRef: MatDialogRef<GemeinkostenBulkUploadDialogComponent>) {}

    openFilePicker() {
        const el = this.fileInput?.nativeElement;
        if (!el) {
            return;
        }
        el.value = '';
        el.click();
    }

    onFileInputChange(event: Event) {
        const input = event.target as HTMLInputElement;
        this.addFiles(input.files ? Array.from(input.files) : []);
        input.value = '';
    }

    onFileDropped(fileList: FileList | File[]) {
        const list = fileList instanceof FileList ? Array.from(fileList) : fileList;
        this.addFiles(list);
    }

    removeFile(index: number) {
        this.files.splice(index, 1);
    }

    clearFiles() {
        this.files = [];
    }

    start() {
        if (this.files.length === 0) {
            return;
        }
        this.dialogRef.close(this.files.slice());
    }

    close() {
        this.dialogRef.close();
    }

    private addFiles(incoming: File[]) {
        const accepted = incoming.filter(f => this.isAccepted(f));
        for (const f of accepted) {
            if (!this.files.some(x => x.name === f.name && x.size === f.size && x.lastModified === f.lastModified)) {
                this.files.push(f);
            }
        }
    }

    private isAccepted(file: File): boolean {
        const name = (file.name || '').toLowerCase();
        const type = (file.type || '').toLowerCase();
        if (name.endsWith('.pdf') || name.endsWith('.xml')) {
            return true;
        }
        return (
            type.includes('pdf') ||
            type.includes('xml') ||
            type === 'application/pdf' ||
            type === 'application/xml' ||
            type === 'text/xml'
        );
    }
}
